import { render, staticRenderFns } from "./TablePromo.vue?vue&type=template&id=14a1ca37&"
import script from "./TablePromo.vue?vue&type=script&lang=js&"
export * from "./TablePromo.vue?vue&type=script&lang=js&"
import style0 from "./TablePromo.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TablePromo.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports